<template>
  <div>
    <modal-work :work-data="workData" />
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button variant="primary" :to="{ name: 'works-create' }">
                <span class="text-nowrap">新增在家工作記錄</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refWorkListTable"
        class="position-relative"
        :items="fetchWorks"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(approve_bit)="data">
          <feather-icon
            v-if="data.item.approve_bit"
            icon="CheckIcon"
            size="18"
            class="mr-50 text-success"
          />
        </template>

        <template #cell(remark)="data">
          <div v-html="data.item.remark"></div>
        </template>
        <template #cell(admin_remark)="data">
          <div v-html="data.item.admin_remark"></div>
        </template>
        <template #cell(id)="data">
          <b-button
            variant="primary"
            v-b-modal.modal-work-user
            @click="showModal(data.item)"
          >
            <span class="text-nowrap">{{ data.item.id }}</span>
          </b-button>
        </template>

        <template #cell(action)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
            v-if="!data.item.approve_bit"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="data.item.approve_bit == 0"
              :to="{ name: 'works-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.approve_bit == 0"
              @click="confirmDelete(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalWorks"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import workStoreModule from "@/views/admin/work/workStoreModule.js";
import useWorksList from "./useWorksList";
import ModalWork from "../works-detail/ModalWork.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ModalWork,
  },

  methods: {
    confirmDelete(id) {
      this.$swal({
        title: "確認刪除?",
        text: "Your action is final and you will not be able to retrieve this work from home record.",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(this.ADMIN_OVERTIME_STORE_MODULE_NAME + "/deleteWork", {
              id: id,
            })
            .then((response) => {
              console.log("response", response);
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    handleCreate() {
      this.id = 0;
      this.resetWorkData();
      this.isAddNewWorkSidebarActive = true;
    },
    showModal(item) {
      //this.$bvModal.show('modal-work')
      this.workData = item;
    },
    handleEdit(item) {
      console.log(item);
      this.id = item.id;
      this.workData.id = item.id;
      this.workData.title = item.title;
      this.workData.remark = item.remark;
      this.workData.time_from = item.time_from;
      this.workData.time_to = item.time_to;
      //this.workData.ot_date = item.ot_date
      this.workData.total_hour = item.total_hour;
      this.workData.approve_bit = item.approve_bit;
      this.workData.admin_remark = item.full_admin_remarkday_bit;
      this.isAddNewWorkSidebarActive = true;
    },
    resetWorkData() {
      this.workData = {
        id: 0,
        title: "",
        remark: "",
        time_from: "",
        time_to: "",
        //ot_date: '',
        total_hour: 0,
      };
    },
  },
  data() {
    return {
      id: 0,
      workData: {},
    };
  },
  setup() {
    const ADMIN_OVERTIME_STORE_MODULE_NAME = "admin-work";

    if (!store.hasModule(ADMIN_OVERTIME_STORE_MODULE_NAME))
      store.registerModule(ADMIN_OVERTIME_STORE_MODULE_NAME, workStoreModule);

    onUnmounted(() => {
      if (store.hasModule(ADMIN_OVERTIME_STORE_MODULE_NAME))
        store.unregisterModule(ADMIN_OVERTIME_STORE_MODULE_NAME);
    });

    const isAddNewWorkSidebarActive = ref(false);

    const {
      fetchWorks,
      tableColumns,
      perPage,
      currentPage,
      totalWorks,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refWorkListTable,
      refetchData,
      ability,
    } = useWorksList();

    return {
      //Sidebar
      isAddNewWorkSidebarActive,

      fetchWorks,
      tableColumns,
      perPage,
      currentPage,
      totalWorks,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refWorkListTable,
      refetchData,
      avatarText,
      ability,
      ADMIN_OVERTIME_STORE_MODULE_NAME,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
